export default function getResource(label, vars = []) {
    const resources = {
        checkoutWith: 'Checkout with'
    };

    return resources[label];
}
